module.exports = __webpack_public_path__ + "img/link-banner-pt.977ce781.png";